// @react
import React, { ReactElement } from 'react'
// @types
import {
  GetConstantsQuery,
  GetConstantsQueryVariables,
  GetUserQuery,
  GetUserQueryVariables,
} from 'lib/graphql/graphqlTypes'
// @graphQL
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
import { GET_CONSTANTS } from 'graphql/queries/constants.query'
// @module components
import EducationForm from 'modules/onBoarding/components/Education/Form'
import QueryError from 'modules/common/components/Errors/QueryError'

const EducationContainer = (): ReactElement => {
  /******************************************
   * GQL HOOKS
   ******************************************/

  const {
    loading: isUserLoading,
    error: isUserError,
    data: userData,
    refetch,
  } = useQuery<GetUserQuery, GetUserQueryVariables>(GET_USER, {
    fetchPolicy: 'cache-first',
  })

  const {
    loading: isConstantsLoading,
    error: isConstantsError,
    data: constantsData,
  } = useQuery<GetConstantsQuery, GetConstantsQueryVariables>(GET_CONSTANTS, {
    fetchPolicy: 'cache-first',
  })

  /******************************************
   * RENDER
   ******************************************/

  const isLoading = isUserLoading || isConstantsLoading

  if (
    isUserError ||
    isConstantsError ||
    (!isLoading && (!userData || !constantsData))
  )
    return <QueryError />

  return (
    <EducationForm
      data={userData}
      constants={constantsData}
      isLoading={isLoading}
      refetch={refetch}
    />
  )
}

export default EducationContainer
